import { useMemo } from 'react'

const useGroupedCards = (cards) => {
  const groupedCards = useMemo(() => {
    if (!cards.some((card) => card.position)) {
      return cards.map((card) => [card])
    }

    const newCards = [...cards]
    newCards.sort((a, b) => a.position - b.position)

    const groupedCards = newCards.reduce((acc, card, index) => {
      if (acc.length === 0) {
        acc[card.position || index] = [card]
        return acc
      } else {
        if (card.position) {
          if (acc[card.position]) {
            acc[card.position].push(card)
            acc[card.position].sort((a, b) => a.tabPosition - b.tabPosition)
          } else {
            acc[card.position] = [card]
          }
        } else {
          acc[index] = [card]
        }
      }
      return acc
    }, []).filter(Boolean)

    return groupedCards
  }, [cards])

  return groupedCards
}

export default useGroupedCards
